export const AI_SUMMARY_COPY_BUTTON_DISABLED_TIMEOUT = 5000

export const QA_NAME_COPY_SUMMARY_BUTTON = 'copySummary'
